"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getContentType_1 = require("../helpers/getContentType");
const getProgressMeasureUpdatedEvent_1 = require("../helpers/getEvent/getProgressMeasureUpdatedEvent");
const getState_1 = require("../helpers/getState");
const entity_1 = require("../type/entity");
const getProgressMeasureForCurriculum_1 = require("./helpers/getProgressMeasureForCurriculum");
const getProgressMeasureForTimeBasedContent_1 = require("./helpers/getProgressMeasureForTimeBasedContent");
const updateProgressMeasureForCheckpoint_1 = require("./helpers/updateProgressMeasureForCheckpoint");
const updateProgressMeasureForILT_1 = require("./helpers/updateProgressMeasureForILT");
const updateProgressMeasureForNonLeafNode_1 = require("./helpers/updateProgressMeasureForNonLeafNode");
/**
 * Updates progressMeasure field and return
 * progressMeasureUpdated event if updated.
 */
function updateProgressMeasure(command, user, content, states, resetProgressFlag) {
    const events = [];
    const state = getState_1.getStateByContentIdUserId(states, content._id, user.userId);
    const currentProgressMeasure = state.progressMeasure;
    const contentType = getContentType_1.getContentType(content);
    switch (contentType) {
        case entity_1.ContentType.LEARNING_CARD:
            if (content.completionType === 'timeBased') {
                state.progressMeasure = getProgressMeasureForTimeBasedContent_1.getProgressMeasureForTimeBasedContent(content.content.duration, content.content.subType, state.timeSpent);
            }
            break;
        case entity_1.ContentType.CHANNEL_CARD:
            state.progressMeasure = getProgressMeasureForTimeBasedContent_1.getProgressMeasureForTimeBasedContent(content.duration, content.modelType, state.timeSpent);
            break;
        case entity_1.ContentType.ASSIGNMENT_CARD:
        case entity_1.ContentType.PEER_REVIEW_CARD:
        case entity_1.ContentType.SECTION:
        case entity_1.ContentType.COURSE:
            updateProgressMeasureForNonLeafNode_1.updateProgressMeasureForNonLeafNode(state, user, content, states, resetProgressFlag);
            break;
        case entity_1.ContentType.CURRICULUM: {
            // NOTE: Ideally should use same
            // updateProgressMeasureForNonLeafNode used for course.
            // Need refactoring in structure of curriculum offer and
            // states for Checkpoint and ILT.
            state.progressMeasure = getProgressMeasureForCurriculum_1.getProgressMeasureForCurriculum(user, content, states);
            break;
        }
        case entity_1.ContentType.CHECKPOINT:
            updateProgressMeasureForCheckpoint_1.updateProgressMeasureForCheckpoint(state);
            break;
        case entity_1.ContentType.ILT:
            updateProgressMeasureForILT_1.updateProgressMeasureForILT(state, states);
            break;
        default:
            break;
    }
    if (currentProgressMeasure !== state.progressMeasure) {
        const { userId, companyId } = user;
        const updatedProgressMeasure = state.progressMeasure;
        const progressMeasureUpdatedEvent = getProgressMeasureUpdatedEvent_1.getProgressMeasureUpdatedEvent(command, companyId, userId, content._id, contentType, currentProgressMeasure, updatedProgressMeasure);
        events.push(progressMeasureUpdatedEvent);
    }
    return events;
}
exports.updateProgressMeasure = updateProgressMeasure;
//# sourceMappingURL=updateProgressMeasure.js.map